module.exports = __webpack_public_path__ + "img/6e96858c5f69e6499ddcf03a917c9a59.svg";